import React from 'react'
import './FlaskBar.less'
import Tooltip from '../../common/tooltip/Tooltip'

interface IFlaskBarProps {
  percentage: number | null
  tooltipText?: JSX.Element | string | null
  title: string
}

const FlaskBar = ({ percentage, title, tooltipText }: IFlaskBarProps) => {
  return (
    <Tooltip text={tooltipText} className={'FlaskBar'}>
      <div className="FlaskBar__filling">
        <div
          className="FlaskBar__filling active"
          style={{ height: `${percentage}%` }}
        ></div>
      </div>
      <div className="FlaskBar__title">{title}</div>
      <div className="FlaskBar__percentage">
        {Number.isInteger(percentage) ? <>{percentage}%</> : ''}
      </div>
    </Tooltip>
  )
}

export default FlaskBar
